import {AppConfig} from "../app/shared/models/appConfig";

export const environment: AppConfig = {
    production: true,
    title: "Legislative Analysis System",
    shortName: "LAS",
    version: "1.0.118",
    basePath: "/",
    tenantId: "0235ba6b-2cf0-4b75-bc5d-d6187ce33de3",
    clientId: "#{clientId}#",
    redirectUri: "#{redirectUri}#",
    apiUrl: "#{apiUrl}#",
    microServiceUrl: "#{microServiceUrl}#",
    apiClientId: "#{apiClientId}#",
    apiClientScope: "api://#{apiClientId}#/access_as_user",
    logToConsole: true,
    defaultTestUrl: "dev/dev/users/all",
    defaultSession: "#{defaultSession}#",
    piiLoggingEnabled: false,
    tenant: "#{tenant}#",
    idleSeconds: parseInt("#{idleSeconds}#"),
    timeoutSeconds: parseInt("#{timeoutSeconds}#"),
    idleInterrupts: 'keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll'
};
